/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Household_Quick_RegisterInputs */

const fr_household_quick_register = /** @type {(inputs: Household_Quick_RegisterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inscrire ${i?.name}`)
};

/**

* @param {Household_Quick_RegisterInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_quick_register = /** @type {((inputs: Household_Quick_RegisterInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Quick_RegisterInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_quick_register(inputs)
});